"use strict";
import { __require as f } from "./index.es103.js";
import { __require as c } from "./index.es104.js";
import { __require as p } from "./index.es105.js";
import { __require as q } from "./index.es106.js";
import { __require as m } from "./index.es107.js";
var n, i;
function k() {
  if (i) return n;
  i = 1;
  var t = /* @__PURE__ */ f(), u = /* @__PURE__ */ c(), o = p(), s = q(), h = m(), l = h || s || o;
  return n = function() {
    var r, a = {
      assert: function(e) {
        if (!a.has(e))
          throw new t("Side channel does not contain " + u(e));
      },
      delete: function(e) {
        return !!r && r.delete(e);
      },
      get: function(e) {
        return r && r.get(e);
      },
      has: function(e) {
        return !!r && r.has(e);
      },
      set: function(e, d) {
        r || (r = l()), r.set(e, d);
      }
    };
    return a;
  }, n;
}
export {
  k as __require
};
//# sourceMappingURL=index.es63.js.map
